export const START_DATE = 'start_date';
export const END_DATE = 'end_date';
export const USERS = 'user_ids';
export const GROUPS = 'group_ids';
export const LOCATIONS = 'location_ids';
export const TAG_IDS = 'tag_ids';
export const TAGS = 'tags';
export const FILTER_PHOTOS_ONLY = 'PHOTOS_ONLY';
export const FILTER_VIDEOS_ONLY = 'VIDEOS_ONLY';
